var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"crm-button",class:[_vm.type, { loading: _vm.loading, transparent: _vm.transparent, 'without-border': _vm.withoutBorder, 'content-width': _vm.contentWidth }],attrs:{"disabled":_vm.disabled || _vm.loading},on:{"click":_vm.onClick}},[(_vm.loading)?_c('div',{staticClass:"crm-preloader"}):[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }